import { connect } from 'react-redux';
import ContactSuccess from '../../components/ContactUs/ContactSuccess';

const mapStateToProps = state => ({
  contactResult: state.form.contactUs
});

export default connect(mapStateToProps)(ContactSuccess);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ContactSuccessContainer.js
 **/